module.exports = __webpack_public_path__ + "static/img/logbg.a1c3f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/saasimg/logbg.png
// module id = F9bE
// module chunks = 84